/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StoreSites } from '../../models/store-sites';

export interface XenialStoresCompanyIdGet$Params {
  'Active-Tenant-Identifier': string;
  companyId: string;
}

export function xenialStoresCompanyIdGet(http: HttpClient, rootUrl: string, params: XenialStoresCompanyIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StoreSites>> {
  const rb = new RequestBuilder(rootUrl, xenialStoresCompanyIdGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('companyId', params.companyId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StoreSites>;
    })
  );
}

xenialStoresCompanyIdGet.PATH = '/xenial/stores/{companyId}';
